<article class="dashboard responsive-8-4">
	<stages-page-header
		[headline]="(pageHeader$ | async)!"
		[breadCrumbTemplate]="(breadCrumb$ | async)!"
		[backButtonDisabled]="(backButtonDisabled$ | async)!"
		[showProcessVersionSwitch]="(showProcessVersionSwitch$ | async)!"
		(backButtonClicked)="onDetailsClosed()"
	></stages-page-header>
	<div class="container row">
		<div class="container column" [ngClass]="(showSecondCard$ | async)! ? 'col-8' : 'col-12'">
			<stages-tab-card [showTabs]="!(showSecondCard$ | async)!" [tabs]="tabs"> </stages-tab-card>
		</div>
		@if (showSecondCard$ | async; as showSecondCard) {
			<div class="container column col-4">
				<stages-card [showHeader]="showSecondCard">
					<ng-container *ngTemplateOutlet="interfacesFilter"></ng-container>
					<div class="footer"></div>
				</stages-card>
			</div>
		}
	</div>
</article>

<ng-template #interfacesFilter>
	<stages-process-interfaces-filter
		[dropdownContent]="(dropdownContent$ | async)!"
		[showSearch]="(showSecondCard$ | async)!"
	/>
</ng-template>
